module.exports = __webpack_public_path__ + "static/media/header-delicias-mobile.bdc2709f.png";